import { createSlice } from '@reduxjs/toolkit';

/**
 * Latest submittal event pushed over the MaintBackend socket.
 * Mirrors IRWebSocket / SnagWebSocket so components consume all three the same way.
 */
const initialState = {
    latestSubmittalEvent: null,
    eventType: null,
};

const submittalWebSocketSlice = createSlice({
    name: 'submittalWebSocket',
    initialState,
    reducers: {
        setSubmittalEvent: (state, action) => {
            state.latestSubmittalEvent = action.payload.data;
            state.eventType = action.payload.eventType;
        },
        clearSubmittalEvent: (state) => {
            state.latestSubmittalEvent = null;
            state.eventType = null;
        }
    }
});

export const { setSubmittalEvent, clearSubmittalEvent } = submittalWebSocketSlice.actions;
export default submittalWebSocketSlice.reducer;
